<template>
  <div id="home">
    <div class="fullpage-container">
      <div class="fullpage-wp" v-fullpage="opts" ref="example">
        <section id="banner" class="page">
          <div class="section container">
            <div class="ribbon">
              <img src="../assets/01.svg" alt="ribbon01" class="img-fluid animated fadeIn delay-1">
              <img src="../assets/02.svg" alt="ribbon02" class="img-fluid animated fadeIn delay-2">
              <img src="../assets/03.svg" alt="ribbon03" class="img-fluid animated fadeIn delay-3">
              <img src="../assets/04.svg" alt="ribbon04" class="img-fluid animated fadeIn delay-4">
            </div>
            <div class="banner">
              <img src="../assets/banner.svg" alt="banner" class="img-fluid">
              <button type="button" class="btn btn-link scroll-down-btn" @click="moveNext">
                進入聖地
                <i class="scroll-down-icon"></i>
              </button>
            </div>
          </div>
        </section>
        <section id="info-1" class="page">
          <div class="section container">
            <div class="title">
              <h1>導言</h1>
              <div class="title_underline"></div>
            </div>
            <div class="slogan text-center mb-3">
              人民的意志
              <br/>
              應是政府權力的基礎
              <br/>
              ──《世界人權宣言》第21條
            </div>
            <div class="content">
              <p>
                〈聖地〉是由聚樂邦與桃園市政府文化局合作開發，以中壢為場域的實境遊戲。同時，這也是第一款以選舉文化作為主題的實境遊戲。玩家在遊戲中，扮演助選員的角色，協助新的候選人鍾立青，共同迎戰昂格立克市（Unglich City）的萬年市長林兆國！
              </p>
            </div>
          </div>
        </section>
        <section id="info-2" class="page">
          <div class="section container">
            <div class="content">
              <p>
                這個網站，是為想更深入了解議題的你而製作，我們將逐步介紹台灣1950年代以降的選舉文化變遷，以及這次故事參照的歷史藍本──中壢事件。此外，遊戲行經的景點，以及遊戲的詳細內容，也都可以在這裡看到。這一次，和我們一起打場不一樣的選戰吧！
              </p>
            </div>
            <div class="reference">
              <ul class="list-unstyled">
                <li>
                  指導單位：文化部、桃園市政府、桃園市議會
                </li>
                <li>
                  主辦單位：桃園市政府文化局
                </li>
                <li>
                  協辦單位：中壢區公所、桃園市立圖書館、中壢仁海宮、新街國小、老街溪河川教育中心、中平路故事館
                </li>
                <li>
                  承辦單位：聚樂邦
                </li>
              </ul>
            </div>
            <router-link to="/vote" class="nav-link">
              <i class="scroll-down-icon"></i>
            </router-link>
          </div>
        </section>
      </div>
      <div class="pager" :class="{'d-none':!this.$root.hasHeader}">
        <a href="javascript:void(0);"
           v-for="btn in pageNum"
           :class="{active:index == btn}"
           @click="moveTo(btn)">
        </a>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Home',
    mounted: function () {
      this.$root.hasHeader = false;
      this.$root.title = '導言';
    },
    data: function () {
      let self = this;

      return {
        index: 0,
        pageNum: 2,
        opts: {
          start: 0,
          beforeChange: function (ele, current, next) {
            self.index = next;

            if (self.index === 0) {
              self.$root.hasHeader = false;
            }
          },
          afterChange: function (ele, current) {
            self.index = current;

            if (self.index > 0) {
              self.$root.hasHeader = true;
            }
          },
        },
      };
    },
    methods: {
      moveNext: function () {
        this.$refs.example.$fullpage.moveNext();
      },
      moveTo: function (index) {
        this.$refs.example.$fullpage.moveTo(index, true);
      },
    },
  };
</script>

<style scoped lang="scss">
  @import "../assets/css/global";

  #home {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;

    #banner {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      background: radial-gradient(circle, $blue, $dark-blue);

      .section {
        padding: 0;
        justify-content: center;
      }

      .ribbon {
        position: absolute;
        width: 100%;
        height: 80vh;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        img {
          position: absolute;
          top: 0;
          left: 0;
          max-height: 100%;
        }
      }

      .banner {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;

        img {
          width: 100px;
        }

        .scroll-down-btn {
          color: #ffffff;
          font-size: 26px;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          margin-top: 50px;
          letter-spacing: 5px;
        }
      }
    }

    h1 {
      text-align: center;
    }

    #info-1, #info-2 {
      .title {
        width: 100%;
        margin-bottom: 30px;

        @include media-breakpoint-down(sm) {
          h1 {
            font-size: 24px;
          }
        }
      }

      .slogan {
        font-style: italic;
        font-size: 15px;
        line-height: 2;
      }

      .content {
        line-height: 2;
      }

      .reference {
        width: 100%;
        font-size: 16px;
        color: #989898;

        @include media-breakpoint-down(sm) {
          font-size: 12px;
        }
      }
    }
  }

  .delay-1 {
    animation-duration: 2s;
    animation-delay: 1s;
  }
  .delay-2 {
    animation-duration: 2s;
    animation-delay: 3s;
  }
  .delay-3 {
    animation-duration: 2s;
    animation-delay: 5s;
  }
  .delay-4 {
    animation-duration: 2s;
    animation-delay: 7s;
  }
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
